module.exports = __webpack_public_path__ + "static/media/id9-lido_azzurro.e536590a.jpg";